import { withInstall } from '@jdesign-vue/utils'

import Badge from './src/badge.vue'

export const JdBadge = withInstall(Badge)
export default JdBadge

export * from './src/badge'
export type { BadgeInstance } from './src/instance'
